import { render } from "./OBBAccordion.vue?vue&type=template&id=5fcaba02"
import script from "./OBBAccordion.vue?vue&type=script&lang=js"
export * from "./OBBAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__